export default "__VITE_ASSET__YcZBc8xL__"